/* Cart drawer extras: upgrades the SellEasy "Others also bought" cards.
   1. Quick add: every card shows a single "Add" button. Multi-size cards
      morph the button into size chips in place on tap (tap-based on purpose,
      hover is unreliable on touch screens); tapping a chip adds through the
      widget's own select + Add flow, so all SellEasy logic is kept.
      Cards whose picker holds a single option get the plain Add button (the
      widget renders a select even when there is nothing to choose).
      Cards whose options don't fit chips (5+ options, long labels) keep the
      restyled select + Add fallback untouched.
   2. Sale percentage badge on the card image when a compare price exists.
   The widget re-injects itself after every cart section rerender, so a
   MutationObserver re-runs the enhancement. Every step is fail-safe: if the
   widget structure changes, cards simply stay in their default form. */
(function () {
  'use strict';

  var CARD_SELECTOR = '.modal-component--cart-drawer lb-upsell-long-card';
  var MAX_CHIPS = 4;
  var MAX_LABEL_LENGTH = 4;

  function parsePriceText(text) {
    if (!text) return NaN;
    var cleaned = String(text).replace(/[^\d.,]/g, '');
    if (!cleaned) return NaN;
    // Treat the last separator as the decimal mark (handles 1.234,56 and 1,234.56)
    var lastComma = cleaned.lastIndexOf(',');
    var lastDot = cleaned.lastIndexOf('.');
    var sep = Math.max(lastComma, lastDot);
    if (sep === -1) return parseFloat(cleaned);
    var intPart = cleaned.slice(0, sep).replace(/[.,]/g, '');
    var decPart = cleaned.slice(sep + 1).replace(/[.,]/g, '');
    return parseFloat(intPart + '.' + decPart);
  }

  function addSaleBadge(card) {
    if (card.querySelector('.hh-upoff')) return;
    var imgCont = card.querySelector('.lb-card-image-cont');
    var saleEl = card.querySelector('.lb-price-sale-price');
    var compareCont = card.querySelector('.lb-compare-cont');
    if (!imgCont || !saleEl || !compareCont) return;

    var compareText = compareCont.textContent || '';
    if (!compareText.trim()) return;

    var sale = NaN;
    var defaultCents = parseFloat(saleEl.getAttribute('lb-default-price'));
    if (isFinite(defaultCents) && defaultCents > 0) {
      sale = defaultCents / 100;
    } else {
      sale = parsePriceText(saleEl.textContent);
    }
    var compare = parsePriceText(compareText);
    if (!isFinite(sale) || !isFinite(compare) || compare <= sale || sale <= 0) return;

    var pct = Math.round((1 - sale / compare) * 100);
    if (pct < 1 || pct > 90) return;

    var badge = document.createElement('span');
    badge.className = 'hh-upoff';
    badge.textContent = '-' + pct + '%';
    imgCont.appendChild(badge);
  }

  function buildQuickAdd(card) {
    if (card.querySelector('.hh-quickadd')) return;
    var select = card.querySelector('select.lb-variant-picker');
    var button = card.querySelector('.lb-button');
    var actions = card.querySelector('.lb-cta-actions');
    if (!button || !actions) return;

    var options = select ? Array.prototype.slice.call(select.options) : [];
    // A picker with a single option is no choice at all: the widget still
    // renders the select, which collapses to a stray chevron next to Add.
    // Treat those cards as variantless -> plain Add button, select hidden.
    if (options.length < 2) select = null;
    if (select) {
      var chipable = options.length <= MAX_CHIPS &&
        options.every(function (opt) {
          var label = (opt.textContent || '').trim();
          return label.length > 0 && label.length <= MAX_LABEL_LENGTH;
        });
      // options that don't fit chips keep the restyled select + Add fallback
      if (!chipable) return;
    }

    var addLabel = (button.textContent || '').trim() || 'Add';

    var qa = document.createElement('div');
    qa.className = 'hh-quickadd';
    qa.setAttribute('data-state', 'idle');

    var addBtn = document.createElement('button');
    addBtn.type = 'button';
    addBtn.className = 'hh-qa-add';
    addBtn.textContent = addLabel;
    qa.appendChild(addBtn);

    if (select) {
      var chipsWrap = document.createElement('div');
      chipsWrap.className = 'hh-upchips hh-qa-chips';
      options.forEach(function (opt) {
        var chip = document.createElement('button');
        chip.type = 'button';
        chip.className = 'hh-upchip';
        chip.textContent = (opt.textContent || '').trim();
        chip.setAttribute('aria-label', addLabel + ' ' + chip.textContent);
        chip.addEventListener('click', function () {
          try {
            qa.setAttribute('data-state', 'busy');
            chip.classList.add('--busy');
            select.value = opt.value;
            select.dispatchEvent(new Event('input', { bubbles: true }));
            select.dispatchEvent(new Event('change', { bubbles: true }));
            button.click();
            window.setTimeout(function () {
              chip.classList.remove('--busy');
              qa.setAttribute('data-state', 'idle');
            }, 5000);
          } catch (err) {
            chip.classList.remove('--busy');
            qa.setAttribute('data-state', 'idle');
          }
        });
        chipsWrap.appendChild(chip);
      });
      qa.appendChild(chipsWrap);
    }

    addBtn.addEventListener('click', function () {
      if (select) {
        qa.setAttribute('data-state', 'pick');
        return;
      }
      try {
        qa.setAttribute('data-state', 'busy');
        button.click();
        window.setTimeout(function () {
          qa.setAttribute('data-state', 'idle');
        }, 5000);
      } catch (err) {
        qa.setAttribute('data-state', 'idle');
      }
    });

    actions.appendChild(qa);
    card.classList.add('hh-has-qa');
  }

  function enhanceCard(card) {
    if (card.getAttribute('data-hh-enhanced') === 'true') return;
    // The widget hydrates asynchronously; only mark done once the card is
    // fully populated (controls present, price text set, select options in).
    var actions = card.querySelector('.lb-cta-actions');
    var button = card.querySelector('.lb-button');
    var priceEl = card.querySelector('.lb-price-sale-price');
    if (!actions || !button || !priceEl || !priceEl.textContent.trim()) return;
    var select = card.querySelector('select.lb-variant-picker');
    if (select && select.options.length === 0) return;
    try {
      addSaleBadge(card);
      buildQuickAdd(card);
    } catch (err) {
      /* leave the card in its default working state */
    }
    card.setAttribute('data-hh-enhanced', 'true');
  }

  function scan() {
    var cards = document.querySelectorAll(CARD_SELECTOR);
    for (var i = 0; i < cards.length; i++) enhanceCard(cards[i]);
  }

  var scheduled = false;
  function scheduleScan() {
    if (scheduled) return;
    scheduled = true;
    window.requestAnimationFrame(function () {
      scheduled = false;
      scan();
    });
  }

  function init() {
    scan();
    var observer = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        if (mutations[i].addedNodes && mutations[i].addedNodes.length) {
          scheduleScan();
          return;
        }
      }
    });
    observer.observe(document.body, { childList: true, subtree: true });

    // tap outside an open size picker folds it back to the Add button
    // (capture phase: runs before the tap that OPENS a picker mutates state)
    document.addEventListener('click', function (event) {
      var open = document.querySelectorAll('.hh-quickadd[data-state="pick"]');
      for (var i = 0; i < open.length; i++) {
        if (!open[i].contains(event.target)) open[i].setAttribute('data-state', 'idle');
      }
    }, true);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
